import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs'
import Headers from '../components/Headers';

function Blog(props) {
  const link = props.linksDs.find(link => link.link === '/blog');
  const pageTitle = props.lang === 'en' ? link.name_en : link.name_se;
  return (
    <>
      <Headers title={pageTitle} lang={props.lang} clink='/blog' />
      <Breadcrumbs title={pageTitle} lang={props.lang} bgimg="https://mhs.mharis.info/wp-content/uploads/2023/04/bg-about-tms-banner.jpg" />
      <div>Blog</div>
    </>
  )
}

export default Blog
